import Metrics from 'assets/icons/fa/chart-line.svg'

export default Metrics
